import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 21 21", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.501, d: "M4.832 1h15.13v15.09" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.501, d: "M16.514 4.455H1.384v15.09h15.13V4.456zM8.938 8.212v7.515M12.695 11.97H5.18" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
